import { render, staticRenderFns } from "./ImageUploader.vue?vue&type=template&id=70e981d7&scoped=true"
import script from "./ImageUploader.vue?vue&type=script&lang=js"
export * from "./ImageUploader.vue?vue&type=script&lang=js"
import style0 from "./ImageUploader.vue?vue&type=style&index=0&id=70e981d7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e981d7",
  null
  
)

export default component.exports